import styled from "styled-components";

import * as Types from "Types";

import AtomH3 from "Components/Atoms/H3";
import AtomSubtitle1 from "Components/Atoms/Subtitle1";

const Wrap = styled.div<Types.Default>`
   ${({ css }) => css}
`;

const Subtitle1 = styled(AtomSubtitle1)<Types.Default>`
   margin-top: 15px;
   ${({ css }) => css}
`;

export default function XSHead(props: Types.Default) {
   return (
      <Wrap {...props}>
         <AtomH3>
            <p>더 많은 이들에게 다가가기 위해,</p>
            <p>다양한 채널을 운영하고 있습니다</p>
         </AtomH3>
         <Subtitle1>*아이콘을 클릭하면, 해당 채널로 연결됩니다.</Subtitle1>
      </Wrap>
   );
}
